import React from "react";
import { connect } from "react-redux";

function Translated(props) {

    let translated_value = props.selected_language_translations === null
        ? ""
        : props.selected_language_translations[props.section][props.label][props.selected_language]
    ;

    return (
        <>{translated_value}</>
    );
}

const mapStateToProps = state => {
	return {
		selected_language_translations: state.language_translations,
		selected_language: state.selected_language
	};
};

const mapDispatchToProps = {};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Translated);